import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from './AuthProvider';
import Loader from './Components/GlobalLoader/Loader';

export default function RequireAuth() {

  const { authStatus } = useAuth();

  if (authStatus === 'checking') {
    return <Loader message="Loading" />;
  }

  return authStatus === 'authenticated' ? <Outlet /> : <Navigate to="/login" replace />;
}
